/** Venue-local event datetime from DB — never use occurs_at (UTC) for display. */
export const pickEventDateSource = (event: {
  occurs_at_local?: string | null;
  event_occurs_at_local?: string | null;
  event_date?: string | null;
}) => {
  const local = String(event?.event_occurs_at_local || event?.occurs_at_local || "").trim();
  if (local) return local;
  const dateOnly = String(event?.event_date || "").trim();
  return dateOnly;
};

type ParsedSourceDateTime = {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
};

const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const parseEventLocalDateTime = (value?: string | null): ParsedSourceDateTime | null => {
  if (!value) return null;
  const input = String(value).trim();
  if (!input) return null;
  const match = input.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/);
  if (!match) return null;
  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
    hour: Number(match[4] ?? "0"),
    minute: Number(match[5] ?? "0"),
  };
};

export const formatEventSourceDate = (value?: string | null, includeYear = true): string => {
  const parsed = parseEventLocalDateTime(value);
  if (!parsed) return "-";
  const month = monthShortNames[Math.max(0, Math.min(11, parsed.month - 1))] || "Jan";
  if (!includeYear) return `${month} ${parsed.day}`;
  return `${month} ${parsed.day}, ${parsed.year}`;
};

export const formatEventSourceTime = (value?: string | null): string => {
  const parsed = parseEventLocalDateTime(value);
  if (!parsed) return "";
  if (!String(value || "").match(/[T\s]\d{2}:\d{2}/)) return "";
  const h24 = Math.max(0, Math.min(23, parsed.hour));
  const minute = Math.max(0, Math.min(59, parsed.minute));
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${String(h12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
};

export const formatEventSourceDateMMDD = (value?: string | null): string => {
  const parsed = parseEventLocalDateTime(value);
  if (!parsed) return "TBD";
  return `${String(parsed.month).padStart(2, "0")}/${String(parsed.day).padStart(2, "0")}/${parsed.year}`;
};

export const formatEventSourceDateTimeDisplay = (value?: string | null): string => {
  const date = formatEventSourceDateMMDD(value);
  if (date === "TBD") return "-";
  const time = formatEventSourceTime(value);
  return time ? `${date} ${time}` : date;
};
